export const tr = {
    active: 'Kabul edildi',
    archived: 'Arşive taşındı',
    'completed-by-client': 'Ajans tarafından reddedildi',
    'completed-by-date': 'Tarihe göre sona erdi',
    'completed-by-publisher': 'Reklam alanı tarafından reddedildi',
    'preferred-deal': 'Özel anlaşma',
    private_marketplace: 'Özel açık artırma',
    received: 'Alındı'
};
